import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppComponent } from '@app/app.component';
import { applicationConfig } from '@app/app.config';
import * as Sentry from "@sentry/angular";

const sentryRelease =
    typeof window !== 'undefined' &&
    window.SENTRY_RELEASE?.id &&
    window.SENTRY_RELEASE.id !== '__SENTRY_RELEASE__'
        ? window.SENTRY_RELEASE.id
        : undefined;

if ( environment.production )
{
    Sentry.init({
        dsn: "https://d4e01a4f3e5e427bdac00c8663db2f52@o313456.ingest.sentry.io/4506822313312256",
        release: sentryRelease,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    enableProdMode();
}

bootstrapApplication(AppComponent, {...applicationConfig, providers: [provideZoneChangeDetection(), ...applicationConfig.providers]})
    .catch(err => console.error(err));
